import React, { Component } from 'react'
import ReactTable from 'react-table'
import { Button, Form, Modal, Popconfirm, Input, Upload, Icon, message, Tooltip } from 'antd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/jobSitePurchaseOrderActions'
import moment from 'moment'
import { filterCaseInsensitive } from '../../../util'

const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}

class JobSitePurchaseOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null
    }
  }

  componentWillMount() {
    this.props.jobSitePurchaseOrdersRefresh({
      jobId: this.props.jobId
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: { description: row.description }
    })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (this.state.currentId === 0) {
        this.props.createAttachment({
          jobId: this.props.jobId,
          files: values.files,
          description: values.description,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateAttachment({
          jobId: this.props.jobId,
          attachmentId: this.state.currentId,
          files: values.files,
          description: values.description,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteAttachment({
      jobId: this.props.jobId,
      attachmentId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  render() {
    const { contentData } = this.state

    const { getFieldDecorator } = this.props.form
    if (!this.props.jobSitePurchaseOrderActions.jobSitePurchaseOrders) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Purchase Orders"
          okText={contentData ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          maskClosable={false}
        >
          <Form layout="vertical">
            <FormItem label="Files">
              {getFieldDecorator('files', {
                rules: [
                  {
                    required: true,
                    message: 'FFFF cannot be blank.'
                  }
                ],
                initialValue: contentData ? contentData.description : ''
              })(
                <Upload>
                  <Button>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              )}
            </FormItem>
            <FormItem label="Description">
              {getFieldDecorator('description', {
                rules: [
                  {
                    required: true,
                    message: 'Note description cannot be blank.'
                  }
                ],
                initialValue: contentData ? contentData.description : ''
              })(
                <TextArea
                  placeholder="Describe the attachment..."
                  rows={4}
                  initialvalue={contentData ? contentData.description : ''}
                />
              )}
            </FormItem>
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Purchase Orders
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Order
            </div>
          </div>
        </div>
        {this.props.jobSitePurchaseOrderActions.jobSitePurchaseOrders && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSitePurchaseOrderActions.jobSitePurchaseOrders.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobSitePurchaseOrderActions }, ownProps) => ({
  jobSitePurchaseOrderActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

JobSitePurchaseOrders.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSitePurchaseOrders))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSitePurchaseOrders.js